export const DEFAULT_PERSONALIZATION_MAX_LENGTH = 20;
export const PERSONALIZATION_INVALID_CHARACTERS = /[~`@$%^_+=}\]>{\[</:;"'\\|]+/;
